import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectVipCard(data) {
  return request({
    url: `/admin/mini/vipCard/select`,
    method: "POST",
    data,
  });
}

export function addVipCard(data) {
  return request({
    url: `/admin/mini/vipCard/add`,
    method: "POST",
    data,
  });
}

export function updateVipCard(data) {
  return request({
    url: `/admin/mini/vipCard/update`,
    method: "POST",
    data,
  });
}

export function deleteVipCard(data) {
  return request({
    url: `/admin/mini/vipCard/delete`,
    method: "POST",
    data,
  });
}
